import { GetListResponse, Media } from "@app/types";
import HttpService from "@core/services/http/http.service";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _MediaService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Media>>("/admin/api/v2/medias", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public create(body: { media: File }) {
    return HttpService.post("/admin/api/v2/medias", {
      body,
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public delete(mediaId: number) {
    return HttpService.delete(`/admin/api/v2/medias/${mediaId}`);
  }
}

const MediaService = new _MediaService();

export default MediaService;
